export const AuthErrorCodes = {
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGIN_RATE_LIMIT: 'LOGIN_RATE_LIMIT',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
  USER_TOKEN_MISMATCH: 'USER_TOKEN_MISMATCH',
}

export const AuthErrorMessages = {
  [AuthErrorCodes.TOKEN_EXPIRED]: 'Access token has expired',
  [AuthErrorCodes.LOGIN_FAILED]: 'Login failed due to invalid credentials',
  [AuthErrorCodes.LOGIN_RATE_LIMIT]: 'Too many login attempts, please try again later',
  [AuthErrorCodes.SESSION_EXPIRED]: 'Session has expired, please log in again',
  [AuthErrorCodes.USER_TOKEN_MISMATCH]: 'Login failed due to invalid credentials',
}

export class AuthError extends Error {
  constructor(code, message = undefined) {
    const errorMessage = message || AuthErrorMessages[code] || 'Authentication error'
    super(errorMessage)
    this.name = 'AuthError'
    this.code = code
  }
}

export const createTokenExpiredError = (message) =>
  new AuthError(AuthErrorCodes.TOKEN_EXPIRED, message)

export const createLoginFailedError = (message) =>
  new AuthError(AuthErrorCodes.LOGIN_FAILED, message)

export const createLoginRateLimitError = (message) =>
  new AuthError(AuthErrorCodes.LOGIN_RATE_LIMIT, message)

export const createSessionExpiredError = (message) =>
  new AuthError(AuthErrorCodes.SESSION_EXPIRED, message)

export const createUserTokenMismatchError = (message) =>
  new AuthError(AuthErrorCodes.USER_TOKEN_MISMATCH, message)

export const isAuthError = (error) => error instanceof AuthError
